import React, { Fragment, useContext } from 'react';
import { H4, LI, UL, Image, Btn } from '../../../AbstractElements';
import { getallCardTotal, getCartTotal } from '../../../Services/Ecommerce.service';
import CartContext from '../../../Context/Ecommerce/Cart';
import paypal from '../../../assets/images/checkout/paypal.png';
import { Col, Input, Label, Row } from 'reactstrap';
import { CashOnDelivery, CheckPayments, Option1, Option2, PayPal, PlaceOrder, Product, Shipping, Total } from '../../../Constant';

const ProductPlaceOrder = () => {
  const { cart } = useContext(CartContext);

  return (
    <Fragment>
      <Col xl='6' sm='12'>
        <div className='checkout-details'>
          <div className='order-box'>
            <div className='title-box'>
              <div className='checkbox-title'>
                <H4>{Product}</H4>
                <span>{Total}</span>
              </div>
            </div>
            <UL className='simple-list qty d-block'>
              {cart &&
                cart.map((item) => {
                  return (
                    <LI key={item.id}>
                      {item.name} x {item.qty}
                      <span>${getCartTotal(item)}</span>
                    </LI>
                  );
                })}
            </UL>
            <UL className='simple-list  sub-total'>
              <LI>
                Subtotal <span className='count'>$ {getallCardTotal(cart)}</span>
              </LI>
              <LI className='shipping-class'>
                {Shipping}
                <div className='shopping-checkout-option'>
                  <Label className='d-block' htmlFor='chk-ani'>
                    <Input className='checkbox_animated' id='chk-ani' type='checkbox' />
                    {Option1}
                  </Label>
                  <Label className='d-block' htmlFor='chk-ani1'>
                    <Input className='checkbox_animated' id='chk-ani1' type='checkbox' />
                    {Option2}
                  </Label>
                </div>
              </LI>
            </UL>
            <UL className='simple-list sub-total total d-block'>
              <LI>
                {Total}
                <span className='count'>$ {getallCardTotal(cart)}</span>
              </LI>
            </UL>
            <div className='animate-chk'>
              <Row>
                <Col>
                  <Label className='d-block' htmlFor='edo-ani'>
                    <input className='radio_animated' id='edo-ani' type='radio' name='rdo-ani' data-original-title='' title='' />
                    {CheckPayments}
                  </Label>
                  <Label className='d-block' htmlFor='edo-ani1'>
                    <input className='radio_animated' id='edo-ani1' type='radio' name='rdo-ani' data-original-title='' title='' />
                    {CashOnDelivery}
                  </Label>
                  <Label className='d-flex' htmlFor='edo-ani2'>
                    <input className='radio_animated' id='edo-ani2' type='radio' name='rdo-ani' data-original-title='' />
                    {PayPal}
                    <Image className='img-paypal img-fluid' src={paypal} alt='' />
                  </Label>
                </Col>
              </Row>
            </div>
            <div className='text-start order-place'>
              <Btn form='checkoutForm' type='submit' color='primary'>
                {PlaceOrder}
              </Btn>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};
export default ProductPlaceOrder;
